import React, { useEffect, useCallback } from "react";
import { ReactComponent as ErrorIcon } from "assets/ico-error.svg";
import { Button, Modal } from "@pickit/pickit-components";
import "./multiErrorAlert.scss";
import { DeleteAlertProps } from "./types";
import { useTranslation } from "react-i18next";
import { KEYS } from "component/modal/types";

const MultiErrorAlert = ({
  isOpen,
  title,
  children,
  testId,
  onClose,
}: DeleteAlertProps) => {
  const { t } = useTranslation();

  const onKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (
        [KEYS.ESC, KEYS.ENTER, KEYS.NUM_ENTER].includes(event.code) &&
        isOpen
      ) {
        event.preventDefault();
        event.stopPropagation();
        onClose();
      }
    },
    [isOpen, onClose]
  );

  useEffect(() => {
    if (isOpen) document.addEventListener("keydown", onKeyDown);
    else document.removeEventListener("keydown", onKeyDown);

    return () => {
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [isOpen, onKeyDown]);

  return (
    <Modal
      isOpen={isOpen}
      width="560px"
      height="auto"
      onClose={onClose}
      testId={testId}
      closeOnBlur={false}
      overAll
    >
      <div className="alert">
        <div
          className="alert-container"
          id="delete-slot-alert"
          data-testid={`${testId}-container`}
        >
          <div className="alert-content">
            <div className="alert-top">
              <ErrorIcon />
            </div>
            <div className="alert-bottom">
              <div className="alert-title" data-testid={`${testId}-title`}>
                {title}
              </div>
              <div className="alert-body">
                <div className="alert-body-content" data-testid={`${testId}-content`}>{children}</div>
              </div>
              <div className="alert-action">
                <div className="button-container">
                  <Button
                    label={t("global:continue")}
                    status="error"
                    type="button"
                    onClick={onClose}
                    fullWidth
                    testId={`${testId}-button`}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default MultiErrorAlert;
